<label>Application Name or Service Id</label>
<mat-form-field style="width: 100%;">
    <input type="text"
           placeholder="Search"
           aria-label="Search"
           matInput
           [formControl]="searchControl"
           [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        {{ option.name }}
      </mat-option>
    </mat-autocomplete>
</mat-form-field>